import { matchPath } from 'react-router-dom'

import type { User } from '@/data/users'
import { normalizePermissionName } from '@/data'

import { routePermissions } from './routePermissions'

export function hasPermission(
  user: Pick<User, 'permissions'> | null,
  permission: string,
) {
  if (!user) return false
  return user.permissions.includes(normalizePermissionName(permission))
}

export function getRequiredPermission(pathname: string) {
  const match = routePermissions.find(({ pattern }) =>
    matchPath({ path: pattern, end: true }, pathname),
  )

  return match?.permission ?? null
}

export function canAccessPath(user: User | null, pathname: string) {
  const permission = getRequiredPermission(pathname)

  if (!permission) {
    return false
  }

  return hasPermission(user, permission)
}

const landingCandidates = [
  '/lead-flows',
  '/tests',
  '/pixels',
  '/partners',
  '/reporting',
  '/users',
  '/admin/roles',
  '/admin/permissions',
] as const

export function getFirstAccessiblePath(user: User | null) {
  return (
    landingCandidates.find((pathname) => canAccessPath(user, pathname)) ??
    '/403'
  )
}
